import { StyleProp, ViewStyle } from "react-native";
import IconVerified from "src/icons/IconVerified";
import { paddingSmall } from "src/styles/spacing";
import { Pill, Text } from "src/swsh-native";
import Profile from "../Profile";
import ProfilePicture from "../ProfilePicture";

const UserBadge = ({
	userId,
	style,
	containerStyle,
	blur,
	opaque,
	testID,
}: {
	userId: string | null | undefined;
	style?: StyleProp<ViewStyle>;
	containerStyle?: StyleProp<ViewStyle>;
	blur?: boolean;
	opaque?: boolean;
	testID?: string;
}) => {
	if (!userId) return null;
	return (
		<Profile
			testID={testID}
			style={containerStyle}
			userId={userId}
			renderContent={({ firstName, isVerified }) => {
				if (!firstName) return null;
				return (
					<Pill
						style={[
							{
								columnGap: paddingSmall,
							},
							style,
						]}
						blur={blur}
						opaque={opaque}
					>
						<ProfilePicture userId={userId} size={20} />
						<Text semibold>{firstName}</Text>
						{isVerified && <IconVerified size={16} />}
					</Pill>
				);
			}}
		></Profile>
	);
};
export default UserBadge;
